import './services.scss';

import './CouponCarousel/CouponCarousel';

import Screen from '../Shared/Helpers/Screen';

const LOAD_MORE_BULLETS_CLASS = 'js-load-more-bullets';
const BULLET_LIST_CLASS = 'js-bullet-item';

class ServicesPage {
    constructor() {
        this.visibleAmount = 4;
        this.loadMoreAmount = 3;

        this.loadMoreBullets = this.loadMoreBullets.bind(this);
        this.filterBullets = this.filterBullets.bind(this);
    }

    init() {
        if (Screen.isMobile) {
            let buttons = document.getElementsByClassName(LOAD_MORE_BULLETS_CLASS);

            this.filterBullets();

            [...buttons].forEach((item) => {
                item.addEventListener('click', (e) => {
                    this.visibleAmount += this.loadMoreAmount;

                    this.filterBullets();
                });
            });
        }
    }

    filterBullets() {
        let bullets = document.getElementsByClassName(BULLET_LIST_CLASS);

        const HIDDEN_CLASS = 'hidden-xs';

        [...bullets].forEach((item, index) => {
            if (index >= this.visibleAmount) {
                item.classList.add(HIDDEN_CLASS);
            } else {
                item.classList.remove(HIDDEN_CLASS);
            }
        });

        if (this.visibleAmount >= bullets.length) {
            let buttons = document.getElementsByClassName(LOAD_MORE_BULLETS_CLASS);
            [...buttons].forEach((item) => {
                item.classList.add(HIDDEN_CLASS);
            });
        }
    }

    loadMoreBullets() {

    }
}

new ServicesPage().init();

if (module.hot) {
    module.hot.accept();
}


// WEBPACK FOOTER //
// ./Src/Services/services.js